import { rosterAPI } from '@/providers/apis/roster/roster';
import { isAPICatchError } from '@/utils/utils';
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({
    name: 'user-classes-list',
})
export default class UserClassesList extends Vue {

    // -------------------------------------------------------------------------
    // Properties

    private classTableFields = [
        {
            label: 'S.No',
            key: 'index',
        },
        {
            label: 'Class Name',
            key: 'title',
        },
        {
            label: 'Class Code',
            key: 'code',
        },
        {
            label: 'Teacher(s)',
            key: 'teacherCount',
            tdClass: 'teacher-name-list-containter',
        },
    ];

    @Prop()
    private selectedRow: any;

    private isLoading: boolean = false;

    private pullupData: any = [];


    // ------------------------------------------------------------------
    // Hooks
    private created() {
        this.fetchClassListByUserId();
    }

    // ------------------------------------------------------------------
    // Methods

    private fetchClassListByUserId() {
        const sourcedId = this.selectedRow.id;
        const params = {
            sourcedId,
        };
        this.isLoading = true;
        rosterAPI.getClassesDetails(params).then((classList: any) => {
            if (!isAPICatchError(classList)) {
                this.pullupData = classList.classes;
            }
            this.isLoading = false;
        });
    }

    private showClass(teacherDetails: any) {
        this.$emit('onSelectComponent', 'teacher-classes-list', teacherDetails);
    }

}
